export default __webpack_public_path__ + "static/media/outdoor_grill.3ac400a2.svg";